<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell *ngIf="canViewDashboard; else noPermission">

  <app-page-hero
    eyebrow="Container Control Tower"
    title="Container Tracking Overview"
    subtitle="Live land-container supervision for active movement, readiness, storage dwell, exceptions, and case workload.">
    <div actions>
      <p-button *ngIf="canViewCases" label="View Cases" icon="pi pi-list" severity="secondary" [outlined]="true" (click)="viewCases()"></p-button>
      <p-button *ngIf="canCreateCase" label="Booking Intake" icon="pi pi-plus" severity="secondary" [outlined]="true" (click)="createCase()"></p-button>
      <p-button label="Refresh" icon="pi pi-refresh" (click)="loadDashboard()"></p-button>
    </div>
  </app-page-hero>

  <app-dashboard-company-scope-selector
    *ngIf="showGroupCompanySelector"
    [companyGroupName]="activeGroupName"
    [memberCompanies]="groupCompanies"
    [selectedCompanyId]="selectedGroupCompanyId"
    (selectedCompanyIdChange)="onDashboardCompanyScopeChange($event)">
  </app-dashboard-company-scope-selector>

  <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

  <app-page-search-panel
    title="Filter Overview"
    [activeFilters]="activeFilterCount"
    [resultText]="(overview.activeCases?.length || 0) + ' active cases'"
    (search)="loadDashboard()"
    (clear)="clearFilters()">
    <div class="p-fluid grid formgrid">
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="dashboardContainer" pInputText [(ngModel)]="filters.containerNumber">
            <label for="dashboardContainer">Container</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="dashboardBl" pInputText [(ngModel)]="filters.billOfLadingNumber">
            <label for="dashboardBl">BL</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="dashboardCustomer" pInputText [(ngModel)]="filters.customer">
            <label for="dashboardCustomer">Customer</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="dashboardStatus" [options]="statusOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.status" [showClear]="true" styleClass="w-full"></p-select>
            <label for="dashboardStatus">Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-compass"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="dashboardState" pInputText [(ngModel)]="filters.currentState">
            <label for="dashboardState">Current State</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="dashboardReadiness" [options]="readinessOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.readinessStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="dashboardReadiness">Readiness</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-exclamation-triangle"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="dashboardSeverity" [options]="severityOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.exceptionSeverity" [showClear]="true" styleClass="w-full"></p-select>
            <label for="dashboardSeverity">Exception Severity</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-warehouse"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="dashboardFacility" [options]="facilityTypeOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.facilityType" [showClear]="true" styleClass="w-full"></p-select>
            <label for="dashboardFacility">Facility Type</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-arrows-h"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select id="dashboardHandoff" [options]="handoffStatusOptions" optionLabel="label" optionValue="value" [(ngModel)]="filters.handoffStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="dashboardHandoff">Handoff Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datePicker id="dashboardFrom" [(ngModel)]="filters.fromDate" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
            <label for="dashboardFrom">Opened From</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-datePicker id="dashboardTo" [(ngModel)]="filters.toDate" dateFormat="yy-mm-dd" styleClass="w-full"></p-datePicker>
            <label for="dashboardTo">Opened To</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
    </div>
  </app-page-search-panel>

  <div class="dashboard-grid">
    <app-page-data-panel title="Exception Control Tower" subtitle="Highest-priority live exceptions with the next operational action." [resultText]="(overview.exceptionQueue?.length || 0) + ' exceptions'">
      <p-table [value]="overview.exceptionQueue || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '64rem' }">
        <ng-template pTemplate="header">
          <tr><th>Case</th><th>Container</th><th>Exception</th><th>Module</th><th>Age</th><th>Action</th><th>Severity</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td><a class="case-link" (click)="openCase(row.containerCaseId)">{{ row.caseNumber || ('Case #' + row.containerCaseId) }}</a></td>
            <td>{{ row.containerNumber || '-' }}</td>
            <td><div class="strong">{{ row.title }}</div><div class="muted">{{ row.detail }}</div></td>
            <td>{{ sourceModuleLabel(row.sourceModule) }}</td>
            <td>{{ row.ageHours === null || row.ageHours === undefined ? '-' : row.ageHours + 'h' }}</td>
            <td>{{ row.nextAction || '-' }}</td>
            <td><p-tag [value]="row.severity || 'info'" [severity]="tagSeverity(row.severity)"></p-tag></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="7"><div class="table-empty">No active exceptions for the selected filters.</div></td></tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>

    <div class="board-row">
      <app-page-data-panel title="Active Land Transport" subtitle="Movement stages across pickup, dispatch, delivery, and empty return.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.transportBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <p-tag [value]="(item.count || 0) + ''" [severity]="tagSeverity(item.tone)"></p-tag>
          </div>
        </div>
      </app-page-data-panel>

      <app-page-data-panel title="Storage And Dwell" subtitle="Full-container yard, depot, warehouse, and storage execution state.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.storageBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <p-tag [value]="(item.count || 0) + ''" [severity]="tagSeverity(item.tone)"></p-tag>
          </div>
        </div>
      </app-page-data-panel>

      <app-page-data-panel title="Readiness" subtitle="Clearance and operational readiness signals for land movement.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.readinessBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <p-tag [value]="(item.count || 0) + ''" [severity]="tagSeverity(item.tone)"></p-tag>
          </div>
        </div>
      </app-page-data-panel>
    </div>

    <div class="board-row two">
      <app-page-data-panel title="Terminal Yard Activity" subtitle="Gate, slot, hold, inspection, and active yard-visit workload.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.yardBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <p-tag [value]="(item.count || 0) + ''" [severity]="tagSeverity(item.tone)"></p-tag>
          </div>
          <div class="table-empty" *ngIf="!(overview.yardBoard || []).length">No yard activity summary for the selected filters.</div>
        </div>
      </app-page-data-panel>

      <app-page-data-panel title="Transport-Storage Handoffs" subtitle="Planned, ready, blocked, and completed handoff orchestration.">
        <div class="board-list">
          <div class="board-item" *ngFor="let item of overview.handoffBoard || []">
            <div><div class="board-label">{{ item.label }}</div><div class="muted">{{ item.detail }}</div></div>
            <p-tag [value]="(item.count || 0) + ''" [severity]="tagSeverity(item.tone)"></p-tag>
          </div>
          <div class="table-empty" *ngIf="!(overview.handoffBoard || []).length">No handoff summary for the selected filters.</div>
        </div>
      </app-page-data-panel>
    </div>

    <app-page-data-panel title="Yard Occupancy" subtitle="Facility and area slot utilization, active visits, holds, and expired free-time." [resultText]="(yardOccupancy.rows?.length || 0) + ' areas'">
      <div class="occupancy-summary">
        <div><span>Total Slots</span><strong>{{ yardOccupancy.totalSlots || 0 }}</strong></div>
        <div><span>Occupied</span><strong>{{ yardOccupancy.occupiedSlots || 0 }}</strong></div>
        <div><span>Available</span><strong>{{ yardOccupancy.availableSlots || 0 }}</strong></div>
        <div><span>Active Visits</span><strong>{{ yardOccupancy.activeVisits || 0 }}</strong></div>
        <div><span>Holds</span><strong>{{ yardOccupancy.holds || 0 }}</strong></div>
        <div><span>Free Time Expired</span><strong>{{ yardOccupancy.expiredFreeTimeCount || 0 }}</strong></div>
      </div>
      <div class="occupancy-grid" *ngIf="yardOccupancy.rows?.length; else noOccupancy">
        <button type="button" class="occupancy-tile" *ngFor="let row of yardOccupancy.rows" (click)="openYardInventory(row)">
          <div>
            <span>{{ row.facilityName || ('Facility #' + row.facilityId) }}</span>
            <strong>{{ row.areaName || 'Unassigned Area' }}</strong>
          </div>
          <p-progressBar [value]="row.occupancyPercent || 0" [showValue]="false"></p-progressBar>
          <div class="occupancy-facts">
            <span>{{ row.occupiedSlots || 0 }}/{{ row.totalSlots || 0 }} slots</span>
            <span>{{ row.activeVisits || 0 }} visits</span>
            <span>{{ row.expiredFreeTimeCount || 0 }} expired</span>
          </div>
        </button>
      </div>
      <ng-template #noOccupancy>
        <div class="table-empty">No yard occupancy rows for the selected company.</div>
      </ng-template>
    </app-page-data-panel>

    <div class="chart-row">
      <app-page-data-panel title="Case Status Mix" subtitle="Lifecycle status distribution.">
        <p-chart type="doughnut" [data]="statusChartData" [options]="chartOptions" height="250px"></p-chart>
      </app-page-data-panel>
      <app-page-data-panel title="Exception Mix" subtitle="Exception count by source module.">
        <p-chart type="doughnut" [data]="exceptionChartData" [options]="chartOptions" height="250px"></p-chart>
      </app-page-data-panel>
      <app-page-data-panel title="Lifecycle Aging" subtitle="Open case aging buckets.">
        <p-chart type="bar" [data]="agingChartData" [options]="chartOptions" height="250px"></p-chart>
      </app-page-data-panel>
    </div>

    <div class="board-row two">
      <app-page-data-panel title="Facility Load" subtitle="Active storage and overdue dwell by facility." [resultText]="(overview.facilityLoad?.length || 0) + ' facilities'">
        <p-table [value]="overview.facilityLoad || []" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr><th>Facility</th><th>Type</th><th>Active Storage</th><th>Yard Visits</th><th>Slots</th><th>Blocked</th><th>Overdue</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.facilityName || '-' }}</td>
              <td>{{ row.facilityType || '-' }}</td>
              <td>{{ row.activeStorageCount || 0 }}</td>
              <td>{{ row.activeYardVisitCount || 0 }}</td>
              <td>{{ row.occupiedSlotCount || 0 }} / {{ row.availableSlotCount || 0 }}</td>
              <td><p-tag [value]="(row.blockedHandoffCount || 0) + ''" [severity]="(row.blockedHandoffCount || 0) > 0 ? 'danger' : 'success'"></p-tag></td>
              <td><p-tag [value]="(row.overdueDwellCount || 0) + ''" [severity]="(row.overdueDwellCount || 0) > 0 ? 'danger' : 'success'"></p-tag></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="7"><div class="table-empty">No active storage load for the selected filters.</div></td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>

      <app-page-data-panel title="Module Coverage" subtitle="How many cases are linked to source operational domains.">
        <div class="coverage-list">
          <div class="coverage-item" *ngFor="let item of overview.moduleCoverage || []">
            <span>{{ item.label }}</span>
            <strong>{{ item.count || 0 }}</strong>
          </div>
        </div>
      </app-page-data-panel>
    </div>

    <app-page-data-panel title="Active Cases" subtitle="Case workload enriched with active leg, readiness, ETA, and exception count." [resultText]="(overview.activeCases?.length || 0) + ' cases'">
      <p-table [value]="overview.activeCases || []" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '104rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Case</th><th>Customer</th><th>Container</th><th>BL</th><th>Status</th><th>State</th><th>Active Leg</th><th>Active Storage</th><th>Facility</th><th>Yard Visit</th><th>Handoff</th><th>Blocked</th><th>Readiness</th><th>ETA</th><th>Exceptions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td><a class="case-link" (click)="openCase(row.containerCaseId)">{{ row.caseNumber || ('Case #' + row.containerCaseId) }}</a></td>
            <td>{{ row.customerLabel || '-' }}</td>
            <td>{{ row.containerNumber || '-' }}</td>
            <td>{{ row.billOfLadingNumber || '-' }}</td>
            <td><p-tag [value]="row.status || '-'" [severity]="tagSeverity(row.status)"></p-tag></td>
            <td>{{ row.currentState || '-' }}</td>
            <td>{{ row.activeLegLabel || '-' }}</td>
            <td>{{ row.activeStorageLabel || (row.activeStorageLegId ? ('Storage #' + row.activeStorageLegId) : '-') }}</td>
            <td>{{ row.activeFacilityType || '-' }}</td>
            <td>{{ row.activeYardVisitLabel || '-' }}</td>
            <td><p-tag [value]="row.handoffStatus || 'NONE'" [severity]="tagSeverity(row.handoffStatus)"></p-tag></td>
            <td><p-tag [value]="(row.blockedHandoffCount || 0) + ''" [severity]="(row.blockedHandoffCount || 0) > 0 ? 'danger' : 'success'"></p-tag></td>
            <td><p-tag [value]="row.readinessStatus || 'PENDING'" [severity]="tagSeverity(row.readinessStatus)"></p-tag></td>
            <td><div class="strong">{{ row.etaDestination || '-' }}</div><div class="muted">{{ row.etaTargetAt | date:'short' }}</div></td>
            <td><p-tag [value]="(row.exceptionCount || 0) + ''" [severity]="(row.exceptionCount || 0) > 0 ? 'danger' : 'success'"></p-tag></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="15"><div class="table-empty">No active cases for the selected filters.</div></td></tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>
  </div>
</app-page-shell>

<ng-template #noPermission>
  <app-page-shell>
    <app-page-data-panel title="Container Tracking Overview" subtitle="You do not have permission to view the container tracking dashboard."></app-page-data-panel>
  </app-page-shell>
</ng-template>
